import en from './en.json';
import zh from './zh.json';
import vi from './vi.json';

export default {
    en,
    zh,
    vi,
};
